module.exports = __webpack_public_path__ + "img/liftUpBtn.ceeb9177.png";